/**
 * Desgins Queries
 */
import gql from 'graphql-tag'

export const desginsQuery = gql`
  query getRelatedItemsStyle($styleName: String!, $productId: Int, $categoryId: Int) {
    relatedItems: getRelatedItemsStyle(styleName: $styleName, productId: $productId, categoryId: $categoryId) {
      name
      image
      productId: product_id
      productName: product_name
      productDescription: product_description
      styleName: style_name
    }
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/DesignCenterRelated/data.ts